<template>
  <v-container class="px-12 pt-12" fluid>
    <v-row class="px-12 pt-8">
      <v-col cols="12" class="d-flex px-6">
        <section class="mr-12 pr-12">
          <v-img width="390" height="342" :src="require('@/assets/communicate-by-channel.svg')"></v-img>
        </section>

        <section class="ml-12 pl-12 comunicate-container">
          <h2>Sua campanha foi ativada com sucesso!</h2>
          <p class="mb-5">Aproveite para comunicar os consumidores dessa oferta, crie uma campanha da Mar.ia e envie comunicado por diferentes canais.</p>
          <section v-if="isSomeChannelAllowed" class="d-flex flex-column align-start">
            <mf-tooltip top :disabled="isChannelTooltipDisabled" max-width="200">
              <template #activator>
                <mf-button
                  icon="arrow_forward"
                  icon-position="right"
                  color="marca-0-l40"
                  :disabled="isCommunicateButtonDisabled"
                  label="Comunicar pela mar.ia"
                  @click="$router.push({ name: 'new-maria-campaign', params: { offerScheduleId } })"
                />
              </template>
              <span>{{ tooltipMessage }}</span>
            </mf-tooltip>
          </section>
          <p class="mt-8 mb-0">Você também pode fazer isso em outro momento. Uma gestão de ofertas pode ser importada em qualquer um de nossos canais.</p>

          <mf-button text :class="isSomeChannelAllowed ? 'mt-5' : ''" data-cy="backToIndex" label="Voltar para o índice" @click="$emit('returnToIndex')" />
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getChannelsPermissionsStatus, checkIfSomeChannelIsAllowed } from '@/modules/campanhas/gestao-ofertas-v2/helpers/channels'

export default {
  name: 'CommunicateByChannel',
  props: {
    offerScheduleId: {
      type: String,
      required: true,
    },
    segments: {
      type: Array,
      default: () => [],
    },
    isDynamicPricingPercentage: {
      type: Boolean,
      default: false,
    },
    hasSpecificHours: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    channelsPermissionsStatus() {
      return getChannelsPermissionsStatus(this.$permissions, this.$getAllowedModules)
    },
    isSomeChannelAllowed() {
      return checkIfSomeChannelIsAllowed(this.channelsPermissionsStatus)
    },
    isChannelTooltipDisabled() {
      return this.channelsPermissionsStatus.maria_campaign && !this.isDynamicPricingPercentage && !this.hasSpecificHours
    },
    isCommunicateButtonDisabled() {
      return !this.channelsPermissionsStatus.maria_campaign || this.isDynamicPricingPercentage || this.hasSpecificHours
    },
    hasSegments() {
      return this.segments?.length > 0
    },
    tooltipMessage() {
      if (this.isDynamicPricingPercentage) {
        return 'Não é possível comunicar campanhas do tipo Percentual por lojas pela Campanha da Mar.ia.'
      }
      if (this.hasSpecificHours) {
        return 'Não é possível comunicar ofertas do tipo horário personalizado pela Campanha da Mar.ia.'
      }
      return 'Você não tem acesso a esse canal. Para mais informações, consulte seu consultor Mercafacil ou o nosso suporte'
    },
  },
}
</script>

<style lang="scss" scoped>
.comunicate-container {
  max-width: 562px;

  h2 {
    font-size: 26px;
    color: $cinza-d10;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    color: $cinza-0;
    line-height: 24px;
  }
}
</style>
